// src/pages/ServicesOverview.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Row, Col, Table } from 'reactstrap';
import './ServicesOverview.scss'
const ServicesOverview = () => {
    const servicesStats = [
        { number: '5+', label: 'Years of Digital Marketing Excellence' },
        { number: '100+', label: 'Successful Client Projects Delivered' },
        { number: '95%', label: 'Client Satisfaction Rate' },
        { number: '3x', label: 'Average ROI for Our Clients' }
    ];

    return (
        <div className="container services-overview">
            {/* Hero Section */}
            <section className="hero-section">
                <Row className="align-items-center mb-6">
                    <Col>
                        <h1 className="display-4 mb-3 mt-5">
                            Our Digital Services
                        </h1>
                        <p className="lead mb-4 mt-5">
                            Comprehensive Solutions for Digital Success
                        </p>
                        <p className="mb-4">
                            At Reachtix, we provide a complete suite of digital marketing services designed to drive growth, enhance visibility, and maximize your return on investment across all digital channels. Our integrated approach ensures every aspect of your digital presence works together seamlessly.
                        </p>
                        <p className="mb-4">
                            From strategic planning to creative execution and data-driven optimization, we help businesses of all sizes achieve their digital marketing goals with measurable results.
                        </p>
                        <div className="d-flex flex-wrap gap-2 mb-4">
                            <Button
                                color="dark"


                                tag={Link}
                                to="/contact-us"
                            >
                                Start Your Digital Journey
                            </Button>
                        </div>
                    </Col>
                </Row>
            </section>

            {/* Stats Section */}
            <Row className="mb-6">
                {servicesStats.map((stat, index) => (
                    <Col lg={6} sm={12} key={index} className="mb-4">
                        <div className="stat-card">
                            <div className="stat-card-number">{stat.number}</div>
                            <div className="stat-card-label">{stat.label}</div>
                        </div>
                    </Col>
                ))}
            </Row>

            {/* Advertising Benefits Section */}
            <section className="mb-6">
                <Row>
                    <Col lg={8}>
                        <h1 className="mb-4">Maximize Your Business Growth with Strategic Advertising</h1>
                        <p className="lead mb-5">
                            Effective advertising transforms visibility into revenue by connecting your brand with motivated customers at the exact moment they're ready to buy. Our data-driven campaigns deliver measurable results that directly impact your bottom line, driving higher conversions, increasing customer lifetime value, and accelerating your return on investment.
                        </p>
                    </Col>
                </Row>
            </section>

            {/* Services Categories Section */}
            <section className="mb-6">
                <Row>
                    <Col lg={8}>
                        <h2 className="mb-4">Our Comprehensive Service Portfolio</h2>
                        <p className="mb-4">
                            Explore our core service categories to find the perfect solution for your business needs:
                        </p>

                        <div className="service-categories">
                            <div className="service-category mb-4 p-4">
                                <h4 className="mb-3">
                                    <i className="fas fa-search text-primary mr-2"></i>
                                    SEO Services
                                </h4>
                                <p className="mb-3">
                                    Improve your organic visibility and drive sustainable traffic growth through comprehensive search engine optimization strategies tailored to your business goals.
                                </p>
                                <Button
                                    color="dark"
                                    tag={Link}
                                    to="/services/seo"
                                >
                                    Explore SEO Services
                                </Button>
                            </div>

                            <div className="service-category mb-4 p-4">
                                <h4 className="mb-3">
                                    <i className="fas fa-ad text-primary mr-2"></i>
                                    Paid Media Services
                                </h4>
                                <p className="mb-3">
                                    Launch and optimize performance-driven advertising campaigns across multiple platforms to reach your target audience and maximize ROI.
                                </p>
                                <Button
                                    color="dark"


                                    color="dark"

                                    tag={Link}
                                    to="/services/ppc"
                                    className=""
                                >
                                    Explore Paid Media
                                </Button>
                            </div>

                            <div className="service-category mb-4 p-4">
                                <h4 className="mb-3">
                                    <i className="fas fa-database text-primary mr-2"></i>
                                    Data & AI Services
                                </h4>
                                <p className="mb-3">
                                    Leverage data analytics and artificial intelligence to gain actionable insights, automate processes, and make smarter marketing decisions.
                                </p>
                                <Button
                                    color="dark"


                                    color="dark"

                                    tag={Link}
                                    to="/services/ai-automation"
                                    className=""
                                >
                                    Explore Data & AI
                                </Button>
                            </div>

                            <div className="service-category mb-4 p-4">
                                <h4 className="mb-3">
                                    <i className="fas fa-chess text-primary mr-2"></i>
                                    Strategy Services
                                </h4>
                                <p className="mb-3">
                                    Develop comprehensive digital strategies through market research, media planning, and expert consultancy to guide your marketing investments.
                                </p>
                                <Button
                                    color="dark"


                                    color="dark"

                                    tag={Link}
                                    to="/services/strategy"
                                    className=""
                                >
                                    Explore Strategy
                                </Button>
                            </div>

                            <div className="service-category mb-4 p-4">
                                <h4 className="mb-3">
                                    <i className="fas fa-palette text-primary mr-2"></i>
                                    Experience Services
                                </h4>
                                <p className="mb-3">
                                    Create compelling user experiences through creative design, conversion optimization, and engaging video content that drives results.
                                </p>
                                <Button
                                    color="dark"


                                    color="dark"

                                    tag={Link}
                                    to="/services/experience"
                                    className=""
                                >
                                    Explore Experience
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </section>

            {/* Benefits Table Section */}
            <section className="mb-6">
                <Row>
                    <Col lg={8}>
                        <h2 className="mb-4">Why Choose Reachtix?</h2>
                        <div className="table-responsive">
                            <Table borderless className="mb-4">
                                <thead>
                                    <tr>
                                        <th className="border-bottom pb-2">Our Advantage</th>
                                        <th className="border-bottom pb-2">Your Benefit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="py-3"><strong>Integrated Approach</strong></td>
                                        <td className="py-3">All services work together for maximum impact</td>
                                    </tr>
                                    <tr>
                                        <td className="py-3"><strong>Data-Driven Decisions</strong></td>
                                        <td className="py-3">Strategic choices based on real performance data</td>
                                    </tr>
                                    <tr>
                                        <td className="py-3"><strong>Cross-Platform Expertise</strong></td>
                                        <td className="py-3">Seamless execution across all digital channels</td>
                                    </tr>
                                    <tr>
                                        <td className="py-3"><strong>Scalable Solutions</strong></td>
                                        <td className="py-3">Services that grow with your business</td>
                                    </tr>
                                    <tr>
                                        <td className="py-3"><strong>Measurable Results</strong></td>
                                        <td className="py-3">Clear ROI tracking and performance reporting</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </section>

            {/* Final CTA Section */}
            <section className="text-center mt-6">
                <h2 className="mb-4">Ready to Transform Your Digital Presence?</h2>
                <p className="mb-4 lead">
                    Let's discuss how our comprehensive digital services can help you achieve your business goals and drive measurable growth.
                </p>
                <div className="d-flex  justify-content-center gap-3">
                    <Button
                        color="dark"



                        tag={Link}
                        to="/contact-us"
                    >
                        Get Started Today
                    </Button>
                    <Button
                        color="dark"

                        tag={Link}
                        to="/contact-us"
                    >
                        Request Free Consultation
                    </Button>
                </div>
            </section>
        </div>
    );
};

export default ServicesOverview;